import { render, staticRenderFns } from "./dashboardPage.vue?vue&type=template&id=1877eff6"
import script from "./dashboardPage.vue?vue&type=script&lang=js"
export * from "./dashboardPage.vue?vue&type=script&lang=js"
import style0 from "./dashboardPage.vue?vue&type=style&index=0&id=1877eff6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports